
import { OpConsumerType } from '../../../models/core'
import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'

import { PopupType } from '../../../helpers/popup-manager'
import { IUserSession, EventsNames, LocalizationHelper, CommonHelper } from '../../../helpers'
import { ConsumerTypeHelper } from '../consumer-types.helper'

import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'


interface ConsumerTypeCreateEditScope extends CreateEditScope { }

export class ConsumerTypeCreateEditController extends CreateEditController {

    // #region Members

    private consumerType: OpConsumerType

    // #endregion


    // #region Ctor

    constructor(
        private $scope: ConsumerTypeCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        protected userSession: IUserSession,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Events

    private onInit(args: any[]): void {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.consumerType = createEditInitParams ? createEditInitParams.referenceObject as any : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.consumerType && this.consumerType.getReferenceKey() > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()

        ConsumerTypeHelper
            .saveConsumerType(this.userSession, ConsumerTypeHelper.createOpConsumerTypeFromIOpObject(objectToSave, this.consumerType))
            .then((savedObject: OpConsumerType) => {
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.consumerTypeSaved, true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject as any)
            })
            .fail((error: any) => {
                deferred.reject(error)
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        return deferred.promise
    }

    // #endregion


    // #region Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: '',
            type: null,
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
            onBulkSave: null,
            onSubmit: null,
            onClose: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.consumerTypeSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
        }
    }

    // #endregion
}